/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_UnderlineInputs */

const en_editor_underline = /** @type {(inputs: Editor_UnderlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Underline`)
};

/**
* | output |
* | --- |
* | "Underline" |
*
* @param {Editor_UnderlineInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const editor_underline = /** @type {((inputs?: Editor_UnderlineInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_UnderlineInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_editor_underline(inputs)
});